<template>
  <div id="app">
    <div class="header link-undecorated">
      <div class="zj-logo pull-left">
        <a href="/" target="_blank" class="text-hide" title="返回用户中心首页">用户中心首页</a>
      </div>
      <div class="header-main text-right">
        <div class="preview pull-left">
          <a href="javascript:void(0)" class="logo-preview z-font-size-16" title="总览" @click.stop="clickHome()">总览</a>
        </div>
        <div class="notice pull-left">
          <span>1</span>
          <a href="/act/vip" target="_blank">终身云vip来了 &nbsp;>查看</a>
        </div>
        <div class="pull-right">
          <div class="header-link header-link-help">
            帮助文档
            <div class="header-drop-list header-list-help z-box-sizing">
              <form class="header-help-form" action="/help/" target="_blank" style="line-height: 1">
                <input type="text" placeholder="请输入您想了解的问题、关键词或产品服务" class="header-help-input z-box-sizing" name="k">
                <input type="submit" class="submit-header-help" value="">
              </form>
              <!--<div class="z-color-muted line-height-1 z-margin-bottom-15-precent" style="line-height: 1">
                您可能需要以下帮助
              </div>
              <div class="header-doc-links">
                <a href="javascript:;">产品文档</a>
                <a href="javascript:;">新手帮助</a>
                <a href="javascript:;">自助服务</a>
              </div>-->
            </div>
          </div>
          <div class="header-link header-link-message">
            <el-badge :value="msg.num" style="text-indent: 0;line-height: 0">
              <span class="z-font-size-14">站内信</span>
            </el-badge>
            <div v-show="msgshow" class="header-drop-list header-list-messages z-box-sizing">
              <div v-show="msg.list.length == 0" class="message-empty">
                您暂时没有站内消息，<a href="javascript:;" class="z-color-a" @click="AllMessage">查看更多 &gt;</a>
              </div>
              <ul v-show="msg.list.length > 0">
                <li v-show="index < 5" v-for="(item, index) in msg.list">
                  <div class="header-message-type">
                    <a class="black-link pull-left width-210 z-oneline-overflow-hidden" href="javascript:;" @click="GoMessage(item.id)" :title="item.title">
                      {{item.title}}
                    </a>
                    <span class="header-message-time text-muted pull-right">
                      {{item.pub_time.split(' ')[0]}}
                    </span>
                  </div>
                </li>
              </ul>
              <div v-show="msg.list.length > 0" class="z-textAlign-center header-message-all" style="">
                <a href="javascript:;" class="black-link" @click="MoreMessage">查看全部未读消息</a>
              </div>
            </div>
          </div>
          <div class="header-link header-link-payment">
            费用
            <div class="header-drop-list header-list-finance z-box-sizing">
              <div class="text-muted">
                您的账户余额
                <a href="javascript:;" class="pull-right z-color-a" @click="goChongzhi">充值</a>
              </div>
              <div class="header-finance-money z-color-66-orange z-margin-bottom-5-precent">
                <span class="z-font-size-24">{{money}}</span><span class="z-font-size-14">元</span>
              </div>
              <div class="header-finance-btns clearfix">
                <el-button @click="goCoupon">优惠券</el-button>
                <el-button @click="goInvoice">开具发票</el-button>
              </div>
              <ul class="header-finance-links">
                <li class="header-finance-last-link">
                  <a href="javascript:;" @click="goCaiwu">收支明细</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="header-link header-link-workorder">
            工单
            <ul class="header-drop-list header-list-workorder">
              <li>
                <a href="javascript:;" @click="subGongDan">提交工单</a>
              </li>
              <li>
                <a href="javascript:;" @click="goGongDan">我的工单</a>
              </li>
            </ul>
          </div>
          <div class="header-link header-link-user header-link-drop z-box-sizing">
            <span class="header-username z-font-size-14">您好，{{username}}</span>
            <ul class="header-drop-list header-user-links">
              <li>
                <a href="javascript:;" @click="goInfo">基本信息</a>
              </li>
              <li>
                <a href="javascript:;" @click="goSafe">安全设置</a>
              </li>
              <li>
                <a href="javascript:;" @click="goId">实名认证</a>
              </li>
              <li>
                <a href="javascript:;" @click="goLog">操作日志</a>
              </li>
              <li class="header-finance-last-link">
                <a href="javascript:;" @click="Loginout">安全退出</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="menu-list">
        <ul>
          <li v-for="(menu, idx) in menuList" :class="{'active': idx === menuIndex}" @click="clickMenu(idx)">
            <a class="z-font-size-14" href="javascript:void(0)">{{menu}}</a>
          </li>
        </ul>
      </div>
      <router-view :flag="flag" ref="cl"/>
    </div>
    <el-dialog
      class="coupon-dialog"
      title="提示"
      :visible.sync="dialogVisible"
      width="612px"
      :close-on-click-modal="false"
      top="5vh"
      :lock-scroll="false">
      <span slot="title" class="dialog-footer"></span>
      <div class="coupon">
        <div class="coupon-content">
          <h4>300元大额优惠券</h4>
          <p>截止时间2018年11月13日，过期无效</p>
          <span class="coupon-btn">立即查看</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import userService from 'business/userService.js'
  import loginService from 'business/loginService.js'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    name: 'app',
    data() {
      return {
        dialogVisible:false,
        menuList: ['账户', '财务', '产品', '工单', '备案'],
        menuIndex: 0,
        username:'',
        money:'',
        msgshow:true,
        flag:false,//控制开始index页面
      }
    },
    created () {
      this.checkLogin('userInfo','cmd=userinfo')
    },
    mounted(){
      let firstMenu = sessionStorage.getItem('firstMenu') ? sessionStorage.getItem('firstMenu') : 0
      this.menuIndex = Number(firstMenu)
    },
    computed: {
      ...mapGetters({
        msg:'getMsg'
      })
    },
    watch:{
      '$route' (val) {
        let x;
        //路由映射
        switch (val['name']) {
          case 'index':
          case 'user1':
          case 'auth':
          case 'personalAuth':
          case 'enterpriseAuth':
          case 'successAuth':
          case 'oplog':
          case 'user3':
          case 'user4':
          case 'user5':
          case 'weixin':
            x = 0;
            break;
          case 'caiwu1':
          case 'caiwu2':
          case 'caiwu3':
          case 'voucher':
          case 'caiwu4':
          case 'invoicelist':
          case 'invoiceinfo':
          case 'invoiceadd':
          case 'invoiceedit':
          case 'client':
          case 'bill':
            x = 1;
            break;
          case 'freeVhostList':
          case 'freeVhost':
          case 'freeServerList':
          case 'freeVhost':
          case 'freeServer':
          case 'freeBeian':
          case 'domainList':
          case 'domainMod':
          case 'domainAddMod':
          case 'domainEditMod':
          case 'vhostList':
          case 'fuwu4':
          case 'fuwu5':
          case 'vhostDelay':
          case 'serverList':
          case 'product7':
          case 'domain':
          case 'vhost':
          case 'server':
          case 'domainout':
            x = 2;
            break;
          case 'fuwu1':
          case 'fuwu2':
          case 'fuwu3':
            x = 3;
            break;
          case 'beian1':
          case 'icpMain':
          case 'beian3':
          case 'beian4':
          case 'icpContent':
          case 'beian6':
          case 'beian7':
          case 'beian8':
          case 'beian9':
          case 'beian10':
          case 'share':
            x = 4;
            break;
        }
        this.menuIndex = x
        sessionStorage.setItem('firstMenu',x)
      }
    },
    methods: {
      ...mapActions(['MSG']),
      clickMenu(idx) {
        this.flag = false
        this.$route.params.page = false
        let cunIndex = this.menuIndex
        this.menuIndex = idx
        if(this.menuIndex != cunIndex) {
          if( idx === 0 ) {
            this.$router.push('/user')
          }else if(idx === 1){
            this.$router.push('/caiwu')
          }else if(idx === 2){
            this.$router.push('/product')
          }else if(idx === 3){
            this.$router.push('/fuwu')
          }else if(idx === 4){
            this.$router.push('/beian')
          }
          sessionStorage.setItem('secondMenu',0)
          sessionStorage.setItem('threeMenu',0)
        }
      },
      clickHome(){
        this.clickMenu(0)
        this.$refs.cl.clickList(0)
        this.$router.push('/user');
      },
      async checkLogin(urlType,data) {
        let {vueData, state} = await userService.transformToVue(urlType,'POST',data)

        if(vueData.response == 200 ) {
          let msg = vueData.msg
          this.username = msg.cert_name || msg.ID_Mobile
          this.money = msg.money

          this.MSG({
            num:vueData.msg.msg_count,
            list:vueData.msg.msg_unread
          })
        }else{
          window.location = "/login/";
        }
      },
      async Loginout() {
        let {vueData, state} = await loginService.transformToVue('loginInfo','GET')
        if(vueData.response == 200 ) {
          window.location = "/index.html";
        }else{

        }
      },
      MoreMessage() {
        this.msgshow = false
        this.$router.push('/message')
        setTimeout(() => {
          this.msgshow = true
        },500)
      },
      AllMessage() {
        this.msgshow = false
        this.$router.push('/message')
        setTimeout(() => {
          this.msgshow = true
        },500)
      },
      GoMessage(id) {
        this.msgshow = false
        this.$router.push('/message/content/'+ id)
        setTimeout(() => {
          this.msgshow = true
        },500)
      },
      goChongzhi() {
        this.$router.push('/caiwu')
      },
      goCoupon() {
        //跨二级路由不执行watch，所以放入sessionStorage，执行mounted
        sessionStorage.setItem('secondMenu',2)
        sessionStorage.setItem('threeMenu',0)
        this.$router.push('/voucher')
      },
      goInvoice() {
        sessionStorage.setItem('secondMenu',3)
        sessionStorage.setItem('threeMenu',1)
        this.$router.push('/invoicelist')
      },
      goCaiwu() {
        sessionStorage.setItem('secondMenu',1)
        sessionStorage.setItem('threeMenu',0)
        this.$router.push('/caiwu2')
      },
      subGongDan() {
        sessionStorage.setItem('secondMenu',0)
        sessionStorage.setItem('threeMenu',0)
        this.$router.push('/fuwu')
      },
      goGongDan() {
        sessionStorage.setItem('secondMenu',0)
        sessionStorage.setItem('threeMenu',1)
        this.$router.push('/fuwu2')
      },
      goSafe() {
        sessionStorage.setItem('secondMenu',2)
        sessionStorage.setItem('threeMenu',0)
        this.$router.push('/user3')
      },
      goInfo() {
        sessionStorage.setItem('secondMenu',1)
        sessionStorage.setItem('threeMenu',0)
        this.$router.push('/user1')
      },
      goId() {
        this.$router.push('/auth')
      },
      goLog() {
        sessionStorage.setItem('secondMenu',4)
        sessionStorage.setItem('threeMenu',0)
        this.$router.push('/oplog')
      },
    }
  }
</script>

<style>
#app {
  font-family: 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #666;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 110;
  right: 0;
  height: 45px;
  line-height: 20px;
  background: #000;
  color: #fff;
}
.link-undecorated a {
  text-decoration: none;
}
.pull-left {
  float: left!important;
}
.pull-right {
  float: right!important;
}
.zj-logo {
  width: 100px;
  height: 33px;
  background: url(assets/imgs/logo.png) no-repeat center;
  background-size: 100% 100%;
  margin: 7px 0 0 24px;
}
.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}
.zj-logo a {
  display: block;
  width: 100%;
  height: 100%;
}
.header-main {
  position: absolute;
  top: 0;
  left: 219px;
  right: 0;
  min-width: 900px;
  height: 100%;
  line-height: 45px;
  background: #000;
  -webkit-box-shadow: 0 2px 4px rgba(189, 189, 189, 0.72);
  -moz-box-shadow: 0 2px 4px rgba(189, 189, 189, 0.72);
  -ms-box-shadow: 0 2px 4px rgba(189, 189, 189, 0.72);
  -o-box-shadow: 0 2px 4px rgba(189, 189, 189, 0.72);
  shadow: 0 2px 4px rgba(189, 189, 189, 0.72);
}
.text-right {
  text-align: right;
}
.preview {
  display: inline-block;
  padding-left: 20px;
  height: 100%;
  border-left: 1px solid #222222;
}
.preview a {
  display: inline-block;
  width: 64px;
  height: 25px;
  line-height: 25px;
  background: url(assets/imgs/preview.png) no-repeat left;
  vertical-align: middle;
  margin-bottom: 4px;
  color: white;
}
.notice {
  background-color: rgba(255,255,255,0.3);
  height: 30px;
  margin-top: 8px;
  margin-left: 20px;
  line-height: 30px;
  padding-right: 20px;
}
.notice span{
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 9px;
  background-color: #fd0000;
  color: #fff;
  line-height: 18px;
  text-align: center;
  margin-left: 10px;
}
.notice a{
  line-height: 20px;
  color: #fdfa00;
}
/*头部*/
.header-link {
  text-align: center;
  color: #fff;
}
.header-link {
  position: relative;
  float: left;
  padding: 0 24px;
  border-left: 1px solid #000;
  text-indent: 25px;
  background-repeat: no-repeat;
  background-position: 24px center;
  font-size: 14px;
}
.header-link:hover,
.header-link:focus {
  background-color: #2a3440;
  color: #fff;
}
.header-left .header-link {
  font-size: 16px;
}
.header-link.header-link-drop {
  position: relative;
  padding-right: 50px;
}
.header-link.header-link-drop:after {
  content: "";
  position: absolute;
  z-index: 10;
  right: 24px;
  top: 50%;
  margin-top: -3px;
  background: url(assets/imgs/header_icon_drop_arrow.png);
  width: 10px;
  height: 6px;
}
.header-link-message {
  position: relative;
  background-image: url(assets/imgs/header_icon_message.png);
}
.header-link-workorder {
  background-image: url(assets/imgs/header_icon_workorder.png);
}
.header-link-help {
  background-image: url(assets/imgs/header_icon_help.png);
}
.header-link-payment {
  background-image: url(assets/imgs/menu_icon_money_active.png?v=2);
}
.header-link-user {
  width: 194px;
  text-indent: 0;
  text-align: left;
}
.header-username {
  line-height: 1;
  display: inline-block;
  max-width: 124px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
  text-indent: 0;
}
/*下拉*/
.header-drop-list {
  display: none;
  position: absolute;
  top: 45px;
  border: 1px solid #ddd;
  border-top: none;
  background: #fff;
  box-shadow: 0px 2px 5px 1px rgba(0, 0, 0, .12);
  font-size: 12px;
  text-indent: 0;
  color: #a0a2a3;
  line-height: 32px;
  text-align: left;
}
.header-link:hover .header-drop-list {
  display: block;
}
.header-drop-list a.black-link {
  color: #262829;
}
.header-drop-list a.black-link:hover {
  color: #00aaff;
}
.width-210 {
  width: 210px;
}
/*帮助*/
.header-list-help {
  padding: 24px;
  width: 400px;
  right: -1px;
}
.header-help-form {
  position: relative;
}
.header-help-input {
  width: 352px;
  height: 40px;
  line-height: 40px;
  padding-right: 40px;
  color: #262829;
}
.header-help-input:focus {
  color: #262829;
}
.header-help-input::-webkit-input-placeholder {
  font-size: 12px;
  color: #666;
}
.submit-header-help {
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 40px;
  border: none;
  outline: none;
  line-height: 40px;
  background: url(assets/imgs/header_icon_search.png) no-repeat center;
}
.submit-header-help:hover {
  background-image: url(assets/imgs/header_icon_search_active.png);
}
.header-list-help form {
  margin-bottom: 16px;
}
.header-doc-links {
  line-height: 16px;
}
.header-doc-links a {
  display: inline-block;
  border-left: 1px solid #ccc;
  width: 110px;
  height: 16px;
  text-align: center;
  line-height: 16px;
  color: #262829;
}
.header-doc-links a:first-child {
  border-left: none;
}
.header-doc-links a:hover {
  color: #00aaff;
}
.header-finance-links {
  margin-top: 10px;
}
.header-user-links,
.header-finance-links li {
  line-height: 32px;

}
.header-user-links li a,
.header-finance-links li a {
  display: inline-block;
  height: 100%;
  line-height: 32px;
  color: #262829;
}
.header-user-links li a:hover,
.header-finance-links li a:hover {
  color: #00aaff;
}
.header-finance-last-link {
  border-top: 1px solid #eee;
  margin-top: 20px;
  padding-top: 8px;
}
/*消息*/
.header-list-messages {
  right: -1px;
  width: 336px;
  padding: 0 23px;
}
.header-list-messages ul {
  padding-top: 16px;
}
.header-list-messages li {
  height: 32px;
  border-bottom: 1px solid #eee;
}
.header-message-type {
  line-height: 32px;
}
.header-message-all {
  line-height: 48px;
}
.message-empty {
  background: url(assets/imgs/tip_icon_info_16.png) no-repeat 30px center;
  padding: 24px 0;
  color: #636566;
  text-align: center;
}
/*费用*/
.header-list-finance {
  width: 240px;
  right: -1px;
  padding: 10px 24px 8px 20px;
}
.header-finance-money {
  font-size: 24px;
}
.header-finance-money span {
}
.header-finance-btns .ny-btn {
  position: relative;
  width: 97px;
  margin-left: -1px;
}
.header-finance-btns .ny-btn:hover {
  z-index: 2;
}
/*工单*/
.header-list-workorder {
  left: -1px;
  right: -1px;
  padding: 16px 0;
}
.header-list-workorder li {
  line-height: 32px;
  text-align: center;
}
.header-list-workorder li a {
  color: #262829;
}
.header-list-workorder li a:hover {
  color: #00aaff;
}
.header-user-links {
  left: -1px;
  right: -1px;
  padding: 16px 24px 10px 24px;
}
/*左侧列表*/
.main {
  display: flex;
}
.menu-list {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  flex: 0 0 80px;
  position: fixed;
  height: 100vh;
  left: 0px;
  overflow: auto;
  background: #2a3440;
  text-align: center;
  z-index: 99;
}
.menu-list>ul {
  margin-top: 112px;
}
.menu-list>ul>li{
  line-height: 34px;
  color: #fff;
  cursor: pointer;
  transition: all .3s;
  margin-top: 28px;
}
.menu-list>ul>li>a {
  text-decoration: none;
  display: inline-block;
  height: 100%;
  width: 100%;
  color: #fff;
  padding-top: 32px;
}
.coupon-dialog .el-dialog {
  background: none;
  border: 0;
  box-shadow:none;
}
.coupon-dialog .el-dialog__header {
  background: none;
  border: 0;
  padding: 0px 15px 10px;
}
.coupon-dialog .el-dialog__headerbtn {
  background: #000;
}
.coupon-dialog .el-dialog__body {
  padding: 0;
}
.coupon {
  width: 612px;
  height: 552px;
  background: url(assets/imgs/coupon.png) no-repeat;
}
.coupon-content {
  text-align: center;
  width: 487px;
  height: 224px;
  padding: 197px 0 0 71px;
}
.coupon-content h4 {
  margin-top: 35px;
  font-size: 48px;
  color: #ffff00;
  line-height: 80px;
}
.coupon-content p{
  font-size: 22px;
  color: #fff;
}
.coupon-btn {
  cursor: pointer;
  display: inline-block;
  padding: 7px 20px;
  font-size: 16px;
  color: #000;
  background-color: #fff;
  border: 1px solid #000;
  border-radius: 4px;
  margin-top: 22px;
}
.menu-list>ul>:nth-child(1) a {
  background: url(assets/imgs/user-logo.png) no-repeat;
  background-position: center 10px;
}
.menu-list>ul>:nth-child(2) a {
  background: url(assets/imgs/finance-logo.png) no-repeat;
  background-position: center 10px;
}
.menu-list>ul>:nth-child(3) a {
  background: url(assets/imgs/product-logo.png) no-repeat;
  background-position: center 10px;
}
.menu-list>ul>:nth-child(4) a {
  background: url(assets/imgs/fuwu-logo.png) no-repeat;
  background-position: center 10px;
}
.menu-list>ul>:nth-child(5) a {
  background: url(assets/imgs/beian-logo.png) no-repeat;
  background-position: center 10px;
}
.menu-list>ul>li.active {
  background: #fff;
  color: #04BAF0;
}
.menu-list>ul>:nth-child(1).active a {
  background: url(assets/imgs/user-active-logo.png) no-repeat;
  background-position: center 10px;
}
.menu-list>ul>:nth-child(2).active a {
  background: url(assets/imgs/finance-active-logo.png) no-repeat;
  background-position: center 10px;
}
.menu-list>ul>:nth-child(3).active a {
  background: url(assets/imgs/product-active-logo.png) no-repeat;
  background-position: center 10px;
}
.menu-list>ul>:nth-child(4).active a {
  background: url(assets/imgs/fuwu-active-logo.png) no-repeat;
  background-position: center 10px;
}
.menu-list>ul>:nth-child(5).active a {
  background: url(assets/imgs/beian-active-logo.png) no-repeat;
  background-position: center 10px;
}
.menu-list>ul>li.active a{
  color: #04BAF0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue